import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  name: string;
  role: string;
  location: string;
  content: string;
  imageInitials: string;
}
export function TestimonialCard({
  name,
  role,
  location,
  content,
  imageInitials
}: TestimonialProps) {
  return <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 flex flex-col h-full" data-id="element-228">
      <div className="flex items-center mb-4" data-id="element-229">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-yellow-400 fill-current" data-id="element-230" />)}
      </div>
      <p className="text-gray-700 italic mb-6 flex-grow" data-id="element-231">"{content}"</p>
      <div className="flex items-center mt-auto" data-id="element-232">
        <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 font-bold mr-3 flex-shrink-0" data-id="element-233">
          {imageInitials}
        </div>
        <div data-id="element-234">
          <p className="font-bold text-gray-900 text-sm" data-id="element-235">{name}</p>
          <p className="text-xs text-gray-500" data-id="element-236">{role}</p>
          <p className="text-xs text-gray-400" data-id="element-237">{location}</p>
        </div>
      </div>
    </div>;
}